import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { Save, Plus, X } from "lucide-react"; 
import { Unit } from "../../../types/unit";
import { IconTextButton } from "../../../components/ButtonComponents";

interface UnitDialogProps {
  isOpen: boolean;
  onClose: () => void;
  unit: Unit | null;
  onSave: (data: any) => void;
}

const initialData = {
  name: "",
  code: "", 
};

export const UnitDialog: React.FC<UnitDialogProps> = ({
  isOpen,
  onClose,
  unit,
  onSave,
}) => {
  const [formData, setFormData] = useState(initialData);

  useEffect(() => {
    if (isOpen) {
      if (unit) {
        setFormData({
          name: unit.name,
          code: unit.code, 
        });
      } else {
        setFormData(initialData);
      }
    }
  }, [unit, isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name || !formData.code) return;

    onSave(formData);
    onClose();
  };

  return (
    <Dialog
      header={unit ? "Birimi Düzenle" : "Yeni Birim Ekle"}
      visible={isOpen}
      onHide={onClose}
      modal
      className="w-full md:w-4/12"
      footer={
        <div className="flex justify-end gap-3">
          <IconTextButton onClick={onClose} icon={X} className="btn-cancel">
            İptal
          </IconTextButton>
          <IconTextButton onClick={handleSubmit} icon={unit ? Save : Plus} className="btn-new">
            {unit ? "Güncelle" : "Kaydet"}
          </IconTextButton>
        </div>
      }
    >
      <div className="flex flex-col gap-4 p-2">
        <div className="flex flex-col gap-2">
          <label className="font-semibold">Birim Adı *</label>
          <InputText
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="Örn: Kilogram"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="font-semibold">Birim Kodu *</label>
          <InputText
            value={formData.code}
            onChange={(e) => setFormData({ ...formData, code: e.target.value.toUpperCase() })}
            placeholder="Örn: KG"
          />
        </div>

        
      </div>
    </Dialog>
  );
};